<template>
    <v-dialog v-model="show" persistent no-click-animation transition="" fullscreen fluid>
        <v-container fluid fill-height class="d-flex align-center flex-column loading-overlay">
            <div style="margin: 4rem 0 1.5rem 0;">
                <logo />
            </div>
        
            <img class="vector my-8" :src="asset('fix-bug.png', 'img')" />
            
            <div class="text-center">
                <h1 class="text-center font-weight-medium primary--text text--darken-1">انتظرنا قليلاً ...</h1>
                <h3 class="text-center font-weight-medium my-4 grey--text ">نعمل على تحديث الموقع في الوقت الحالي، سنعود قريباً ...</h3>

                <!-- <v-btn color="primary" tile depressed large class="mt-6">العودة</v-btn> -->
            </div>
            
        </v-container>
    </v-dialog>
</template>
<script>
import globalMethods from '../../../helpers/global-methods'
export default {
    props: ['show'],
    components: {},
    methods: {
        ...globalMethods,
    }
}
</script>
<style lang="scss" scoped>
    .loading-overlay{
        background-color: rgba(255, 255, 255, 1);
        
    }
    .icon-wrapper{
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;

        margin: 3rem auto;
    }
    .vector{
        width: 75%;
        max-width: 450px;
    }
</style>